import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
  GET_PRODUCTHANDOVER,
  DELETE_PRODUCTHANDOVER,
  UPDATE_PRODUCTHANDOVER,
  ADD_NEW_PRODUCTHANDOVER,
} from "./actionType";

import {
  getProductHandoverSuccess,
  getProductHandoverFail,
  deleteProductHandoverSuccess,
  deleteProductHandoverFail,
  updateProductHandoverSuccess,
  updateProductHandoverFail,
  addProductHandoverSuccess,
  addProductHandoverFail,
} from "./action";

//Include Both Helper File with needed carriers
import {
  approveProductHandoverApi,
  getProductHandoverApi,
  updateProductHandoverApi,
  deleteProductHandoverApi,
  addNewProductHandoverApi
} from "../../helpers/backend_helper";

function* getProductHandover({ payload: productHandover }) {
  try {
    const response = yield call(getProductHandoverApi, productHandover);
    yield put(getProductHandoverSuccess(GET_PRODUCTHANDOVER, response.data));
  } catch (error) {
    yield put(getProductHandoverFail(GET_PRODUCTHANDOVER, error));
  }
}

function* onUpdateProductHandover({ payload: productHandover }) {
  try {
    if (productHandover.setApprove) {
      const response = yield call(approveProductHandoverApi, productHandover);
      yield put(updateProductHandoverSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
    else {
      const response = yield call(updateProductHandoverApi, productHandover);
      yield put(updateProductHandoverSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
  } catch (error) {
    yield put(updateProductHandoverFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onDeleteProductHandover({ payload: productHandover }) {
  try {
    const response = yield call(deleteProductHandoverApi, productHandover);
    yield put(deleteProductHandoverSuccess({ productHandover, ...response }));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(deleteProductHandoverFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onAddNewProductHandover({ payload: productHandover }) {
  try {
    const response = yield call(addNewProductHandoverApi, productHandover);
    yield put(addProductHandoverSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(addProductHandoverFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }

}

export function* watchGetProductHandover() {
  yield takeEvery(GET_PRODUCTHANDOVER, getProductHandover);
}

export function* watchUpdateProductHandover() {
  yield takeEvery(UPDATE_PRODUCTHANDOVER, onUpdateProductHandover);
}

export function* watchDeleteProductHandover() {
  yield takeEvery(DELETE_PRODUCTHANDOVER, onDeleteProductHandover);
}

export function* watchAddNewProductHandover() {
  yield takeEvery(ADD_NEW_PRODUCTHANDOVER, onAddNewProductHandover);
}

function* productHandoverSaga() {
  yield all([
    fork(watchGetProductHandover),
    fork(watchDeleteProductHandover),
    fork(watchUpdateProductHandover),
    fork(watchAddNewProductHandover)
  ]);
}

export default productHandoverSaga;
